<div class="page-header">
    <button mat-button class="btn-orange" (click)="goBack()">
        <mat-icon fontIcon="arrow_back"></mat-icon>
        Volver
    </button>
    <h1 class="title">Detalle de liquidación</h1>
</div>

<div *ngIf="!detail" class="text-white">Cargando detalle...</div>

<div *ngIf="detail" class="detail-grid">
    <mat-card class="summary-card">
        <div class="summary-row">
            <div>
                <p class="label">Semana</p>
                <p class="value">{{ detail.week }}</p>
            </div>
            <div>
                <p class="label">Año</p>
                <p class="value">{{ detail.year }}</p>
            </div>
            <div>
                <p class="label">Mes</p>
                <p class="value">{{ detail.month }}</p>
            </div>
            <div>
                <p class="label">Días aplicados</p>
                <p class="value">{{ detail.daysToApply }}</p>
            </div>
            <div *ngIf="isWeekly">
                <p class="label">Rango de fechas</p>
                <p class="value">{{ formatDateDisplay(detail.startDate) }} - {{ formatDateDisplay(detail.endDate) }}</p>
            </div>
        </div>
        <div class="summary-row">
            <div>
                <p class="label">ISR</p>
                <p class="value">{{ paysISR ? 'Aplica' : 'No aplica' }}</p>
            </div>
            <div>
                <p class="label">Estado</p>
                <p class="value">{{ statusText }}</p>
            </div>
            <div *ngIf="detail.rejectionReason">
                <p class="label text-red-400">Motivo rechazo</p>
                <p class="value text-red-300">{{ detail.rejectionReason }}</p>
            </div>
        </div>
    </mat-card>

    <mat-card class="sections-card">
        <h2>Resumen de liquidación</h2>
        <div class="summary-table">
            <table>
                <thead>
                    <tr>
                        <th>Grupo</th>
                        <th *ngIf="isDaily">Fecha</th>
                        <th>Descuentos</th>
                        <th>Concepto</th>
                        <th>Total a facturar</th>
                        <th>Depósito para liberar planilla</th>
                        <th>Total a recibir</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of invoiceRows">
                        <td>{{ getRowGroupLabel(row) }}</td>
                        <td *ngIf="isDaily">{{ formatDateDisplay(row.date) }}</td>
                        <td>
                            <div class="discount-list">
                                <div *ngFor="let d of row.discounts">{{ d.name }}: Q {{ d.amount | number:'1.2-2' }}</div>
                                <div *ngIf="row.isrAmount > 0">ISR: Q {{ row.isrAmount | number:'1.2-2' }}</div>
                                <div *ngIf="row.retentionIVAAmount > 0">RETENCIÓN IVA: Q {{ row.retentionIVAAmount | number:'1.2-2' }}</div>
                            </div>
                        </td>
                        <td>
                            <div *ngIf="row.totalToInvoice > 0 && row.concept" class="concept-cell">
                                <span class="concept-text">{{ row.concept }}</span>
                                <button mat-icon-button (click)="copyConcept(row.concept)" matTooltip="Copiar descripción para facturación">
                                    <mat-icon fontIcon="content_copy"></mat-icon>
                                </button>
                            </div>
                        </td>
                        <td>Q {{ row.totalToInvoice | number:'1.2-2' }}</td>
                        <td>Q {{ (row.netAmount < 0 ? (row.netAmount * -1) : 0) | number:'1.2-2' }}</td>
                        <td>Q {{ (row.netAmount > 0 ? row.netAmount : 0) | number:'1.2-2' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </mat-card>

    <div class="flex flex-col gap-4 uploads-grid">
        <mat-card class="upload-card">
            <div class="card-header">
                <div>
                    <h2>Facturas</h2>
                    <p class="helper">Sube tus facturas en PDF por cada fila.</p>
                </div>
            </div>

            <ng-container *ngIf="canEdit; else invoicesReadOnly">
                <div *ngIf="invoiceRowsToBill.length > 0" class="items-table">
                    <div class="items-rows">
                        <div class="item-row" *ngFor="let item of invoiceRowsToBill; trackBy: trackInvoiceRowByIndex">
                            <div class="file-link-cell">
                                <a *ngIf="item.row.invoice.url || item.row.invoice.previewUrl" [href]="item.row.invoice.url || item.row.invoice.previewUrl" target="_blank" rel="noopener" class="file-link inline-link">
                                    {{ item.row.invoice.fileName || 'Ver archivo' }}
                                </a>
                                <span *ngIf="!item.row.invoice.url && !item.row.invoice.previewUrl" class="text-gray">Sin archivo</span>
                            </div>
                            <div class="fields-row">
                                <div class="flex flex-col gap-1 text-sm text-gray">
                                    <span><strong>Grupo:</strong> {{ getRowGroupLabel(item.row) }}</span>
                                    <span *ngIf="isDaily"><strong>Fecha:</strong> {{ formatDateDisplay(item.row.date) }}</span>
                                </div>
                                <mat-form-field appearance="outline" floatLabel="always" class="form-field-theme w-full border-0">
                                    <mat-label class="text-gray text-lg">Número de factura</mat-label>
                                    <input matInput [(ngModel)]="item.row.invoice.number" class="text-lg text-white bg-blue-primary">
                                    <mat-error *ngIf="isInvoiceNumberInvalid(item.index)">El número es obligatorio.</mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline" floatLabel="always" class="form-field-theme w-full border-0">
                                    <mat-label class="text-gray text-lg">Fecha</mat-label>
                                    <div class="relative">
                                        <input matInput [matDatepicker]="invPicker" [(ngModel)]="item.row.invoice.date" [max]="today" class="text-lg text-white bg-blue-primary" readonly (click)="invPicker.open()">
                                        <mat-datepicker-toggle matSuffix [for]="invPicker" class="datepicker-toggle right-0"></mat-datepicker-toggle>
                                        <mat-datepicker #invPicker></mat-datepicker>
                                    </div>
                                    <mat-error *ngIf="isInvoiceDateInvalid(item.index)">Ingresa una fecha válida.</mat-error>
                                </mat-form-field>
                                <div class="readonly-amount">
                                    <p class="label">Monto</p>
                                    <p class="value">Q {{ item.row.totalToInvoice | number:'1.2-2' }}</p>
                                </div>
                            </div>
                            <div class="actions-row">
                                <button mat-button class="btn-orange" (click)="fileInvoiceInput.click()">Subir PDF</button>
                                <input #fileInvoiceInput type="file" accept="application/pdf" class="hidden-input" (change)="handleInvoiceFileInput($event, item.index)">
                                <button mat-icon-button color="warn" (click)="clearInvoiceFile(item.index)" matTooltip="Limpiar">
                                    <mat-icon fontIcon="delete"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="invoiceRowsToBill.length === 0" class="text-gray">No hay filas de facturación.</div>
            </ng-container>
            <ng-template #invoicesReadOnly>
                <div *ngIf="invoiceRowsToBill.length > 0" class="readonly-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Grupo</th>
                                <th *ngIf="isDaily">Fecha</th>
                                <th>Archivo</th>
                                <th>Número</th>
                                <th>Fecha</th>
                                <th>Monto</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of invoiceRowsToBill; trackBy: trackInvoiceRowByIndex">
                                <td>{{ getRowGroupLabel(item.row) }}</td>
                                <td *ngIf="isDaily">{{ formatDateDisplay(item.row.date) }}</td>
                                <td><a [href]="item.row.invoice.url" target="_blank" rel="noopener" class="file-link inline-link">{{ item.row.invoice.fileName }}</a></td>
                                <td>{{ item.row.invoice.number }}</td>
                                <td>{{ formatDateDisplay(item.row.invoice.date) }}</td>
                                <td>Q {{ item.row.totalToInvoice | number:'1.2-2' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="invoiceRowsToBill.length === 0" class="text-gray">No hay facturas cargadas.</div>
            </ng-template>
        </mat-card>

        <mat-card class="upload-card">
            <div class="card-header">
                <div>
                    <h2>Depósitos</h2>
                    <p class="helper">Sube tus depósitos en PDF por cada fila.</p>
                </div>
            </div>

            <ng-container *ngIf="canEdit; else depositsReadOnly">
                <div *ngIf="depositRowsToBill.length > 0" class="items-table">
                    <div class="items-rows">
                        <div class="item-row" *ngFor="let item of depositRowsToBill; trackBy: trackInvoiceRowByIndex">
                            <div class="file-link-cell">
                                <a *ngIf="item.row.deposit.url || item.row.deposit.previewUrl" [href]="item.row.deposit.url || item.row.deposit.previewUrl" target="_blank" rel="noopener" class="file-link inline-link">
                                    {{ item.row.deposit.fileName || 'Ver archivo' }}
                                </a>
                                <span *ngIf="!item.row.deposit.url && !item.row.deposit.previewUrl" class="text-gray">Sin archivo</span>
                            </div>
                            <div class="fields-row">
                                <div class="flex flex-col gap-1 text-sm text-gray">
                                    <span><strong>Grupo:</strong> {{ getRowGroupLabel(item.row) }}</span>
                                    <span *ngIf="isDaily"><strong>Fecha:</strong> {{ formatDateDisplay(item.row.date) }}</span>
                                </div>
                                <mat-form-field appearance="outline" floatLabel="always" class="form-field-theme w-full border-0">
                                    <mat-label class="text-gray text-lg">Número de depósito</mat-label>
                                    <input matInput [(ngModel)]="item.row.deposit.number" class="text-lg text-white bg-blue-primary">
                                    <mat-error *ngIf="isDepositNumberInvalid(item.index)">El número es obligatorio.</mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline" floatLabel="always" class="form-field-theme w-full border-0">
                                    <mat-label class="text-gray text-lg">Fecha</mat-label>
                                    <div class="relative">
                                        <input matInput [matDatepicker]="depPicker" [(ngModel)]="item.row.deposit.date" [max]="today" class="text-lg text-white bg-blue-primary" readonly (click)="depPicker.open()">
                                        <mat-datepicker-toggle matSuffix [for]="depPicker" class="datepicker-toggle right-0"></mat-datepicker-toggle>
                                        <mat-datepicker #depPicker></mat-datepicker>
                                    </div>
                                    <mat-error *ngIf="isDepositDateInvalid(item.index)">Ingresa una fecha válida.</mat-error>
                                </mat-form-field>
                                <div class="readonly-amount">
                                    <p class="label">Monto</p>
                                    <p class="value">Q {{ item.row.depositAmount | number:'1.2-2' }}</p>
                                </div>
                            </div>
                            <div class="actions-row">
                                <button mat-button class="btn-orange" (click)="fileDepositInput.click()">Subir PDF</button>
                                <input #fileDepositInput type="file" accept="application/pdf" class="hidden-input" (change)="handleDepositFileInput($event, item.index)">
                                <button mat-icon-button color="warn" (click)="clearDepositFile(item.index)" matTooltip="Limpiar">
                                    <mat-icon fontIcon="delete"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="depositRowsToBill.length === 0" class="text-gray">No hay filas de depósito.</div>
            </ng-container>
            <ng-template #depositsReadOnly>
                <div *ngIf="depositRowsToBill.length > 0" class="readonly-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Grupo</th>
                                <th *ngIf="isDaily">Fecha</th>
                                <th>Archivo</th>
                                <th>Número</th>
                                <th>Fecha</th>
                                <th>Monto</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of depositRowsToBill; trackBy: trackInvoiceRowByIndex">
                                <td>{{ getRowGroupLabel(item.row) }}</td>
                                <td *ngIf="isDaily">{{ formatDateDisplay(item.row.date) }}</td>
                                <td><a [href]="item.row.deposit.url" target="_blank" rel="noopener" class="file-link inline-link">{{ item.row.deposit.fileName }}</a></td>
                                <td>{{ item.row.deposit.number }}</td>
                                <td>{{ formatDateDisplay(item.row.deposit.date) }}</td>
                                <td>Q {{ item.row.depositAmount | number:'1.2-2' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="depositRowsToBill.length === 0" class="text-gray">No hay depósitos cargados.</div>
            </ng-template>
        </mat-card>
    </div>

    <div class="actions" *ngIf="canEdit">
        <button mat-flat-button class="btn-orange" (click)="saveDocuments()" [disabled]="uploading">
            Enviar para revisión
        </button>
    </div>
</div>
